const Uppy = require('@uppy/core');
const DragDrop = require('@uppy/drag-drop');
const ProgressBar = require('@uppy/progress-bar');
const XHRUpload = require('@uppy/xhr-upload');
const Dashboard = require('@uppy/dashboard');
const ImageEditor = require('@uppy/image-editor');

const uploadSuccess = (element) => (file, response) => {
  location.reload();
}


$('.file-upload').each((i, elem) => {

  const allowedFileTypes = elem.getAttribute('data-file-types').split(',').map(type => {
    switch (type) {
      case 'pdf':
        return 'application/pdf'
      case 'image':
        return 'image/*'
    }
  });

  const upload = new Uppy({
    meta: {
      collection: elem.getAttribute('data-collection')
    },
    restrictions: {
      allowedFileTypes: allowedFileTypes
    },
  });
  const $this = `#${elem.id}.file-upload`;

  upload.setMeta({ collection: elem.getAttribute('data-collection') });
  upload
    .use(XHRUpload, {
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      method: 'post',
      endpoint: elem.getAttribute('data-url'),
      formData: true,
      bundle: true,
      fieldName: 'media[]',
    });

  upload.on('upload-success', uploadSuccess(`${$this} .upload-files`));

  upload
    .use(Dashboard, {
      inline: false,
      target: 'body',
      trigger: `#show-${elem.id}-uploader`,
      showProgressDetails: true,
      height: 170,
      width: 1400,
      metaFields: [
        { id: 'title', name: 'Title' },
        { id: 'description', name: 'Description (Alt. Text)' }
      ],
      browserBackButtonClose: false
    })
    .use(ImageEditor, {
      target: Dashboard,
      quality: 0.8,
    });
});

$(document).on('click', '.remove-media', function (e) {
  e.preventDefault();
  deleteFile($(this));
});

function deleteFile(element) {
  $.ajax({
    type: 'DELETE',
    url: element.data('url'),
    data: {
      'id': element.data('id')
    }
  }).done(function (response) {
    $parent = element.closest('.fileuploader-item');
    $parent.find('.image-card').remove();
    $parent.find('.add-file').removeClass('hidden');
    element.remove();
    console.log(response);
  }).fail(function (response) {
    console.log('ajaxerror', response);
  });
}
